import Vue from 'vue';
import { IJSONSchema } from './IJSONSchema';
import IValidationError from './IValidationError';
import validationPatterns from './validationPatterns';

export default class ValidationTranslator {
  static generateMessage(schema: IJSONSchema, error: IValidationError): string {
    const { keyword } = error;
    const { params } = error;
    if (keyword === 'required') {
      return Vue.$t('core.validation.required');
    }
    if (keyword === 'minLength') {
      return Vue.$t('core.validation.minLength', params.minLength);
    }
    if (keyword === 'maxLength') {
      return Vue.$t('core.validation.maxLength', params.maxLength);
    }
    if (keyword === 'maximum') {
      return Vue.$t('core.validation.maximum', params.maximum);
    }
    if (keyword === 'minimum') {
      return Vue.$t('core.validation.minimum', params.minimum);
    }
    if (keyword === 'exclusiveMaximum') {
      return Vue.$t('core.validation.maximum', params.exclusiveMaximum - 1);
    }
    if (keyword === 'exclusiveMinimum') {
      return Vue.$t('core.validation.minimum', params.exclusiveMinimum + 1);
    }
    if (keyword === 'contains') {
      const title = params?.contains?.title ?? params?.title;
      const message = title ? 'core.validation.contains' : 'core.validation.general';
      return Vue.$t(message, title);
    }
    if (keyword === 'enum') {
      if (Array.isArray(params.enum) && params.enum.length === 1) {
        if (params.enum[0] === true) {
          return Vue.$t('core.validation.mustBeTrue');
        }
        if (params.enum[0] === false) {
          return Vue.$t('core.validation.mustBeFalse');
        }
      }
    }
    if (keyword === 'pattern') {
      if (params.pattern.startsWith(Vue.$validation.REF_PREFIX)) {
        return Vue.$t('core.validation.sameAs');
      }
      if (params.pattern === validationPatterns.email) {
        return Vue.$t('core.validation.email');
      }
      if (params.pattern === validationPatterns.isoDate) {
        return Vue.$t('core.validation.date');
      }
      if (params.pattern === validationPatterns.isoDateTime) {
        return Vue.$t('core.validation.date');
      }
      if (params.pattern === validationPatterns.url) {
        return Vue.$t('core.validation.url');
      }
      if (params.pattern === validationPatterns.companyUid) {
        return Vue.$t('core.validation.companyUid');
      }
    }
    Vue.$log.warning('[Validation] No specific validation message available for this validation error:');
    Vue.$log.warning(error);
    return Vue.$t('core.validation.general');
  }
}
